import styled from 'styled-components';

export const styles = {
  drawerPaper: {
    width: '95%',
  },
};

export const Main = styled.div`
  width: 100%;
`;

export const Columns = styled.div`
  height: calc(100vh - 49px);
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Details/styles.js